import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const ForPartnersMail = ({ register, errors, defaultValue, disabled=false } : { register: any, errors: any, defaultValue?: any, disabled?: boolean }) => {
    const [isFocused, setIsFocused] = useState<boolean>(false)
    const {t} = useTranslation()

    const handleBlur = () => {
        setIsFocused(false)
    }


    return (
        <div className={`for-partners__input-block ${isFocused && 'for-partners__input-block_focused'}`}>
            <label style={errors.email ? { color: '#D17CF9' } : {}} htmlFor='email'>{errors.email ? errors.email.message : t('footerFormemailUp')}</label>
            <input
                style={errors.email ? { color: '#D17CF9' } : {}}
                autoComplete='off'
                onBlurCapture={handleBlur}
                onFocus={() => setIsFocused(true)}
                name='email'
                type='text'
                placeholder='test@mail.ru'
                defaultValue={defaultValue ? defaultValue : ""}
                disabled={disabled}
                {...register('email', {
                    defaultValue: defaultValue ? defaultValue : "",
                    pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: t('footerFormEmailPatternError'),
                    }, required: t('footerFormrequired')
                })}
            />
        </div>
    )
}

export default ForPartnersMail
